'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtHours', [
	'$i18next',
	function ($i18next) {
		return {
			restrict: 'A',
			replace: true,
			scope: {
				pmtHours: '@',
				diffObject: '=',
				disableHeader: '@'
			},
			link: function (scope, element, attrs) {
				scope.showHeader = true;
				scope.hoursSpecified = false;
				scope.hoursMapper = [];

				const dayKeys = Object.freeze({
					mon: 'mon',
					tue: 'tue',
					wed: 'wed',
					thu: 'thu',
					fri: 'fri',
					sat: 'sat',
					sun: 'sun'
				});
				let fillUpDayMapper = function () {
					// additional complexity brought to you by angular...
					// Wrapping scope.hoursMapper to force angular to repaint when scope.pmtHours change
					scope.hoursMapper = [
						{ prop: dayKeys.mon, display: $i18next.t(`general.${dayKeys.mon}`) },
						{ prop: dayKeys.tue, display: $i18next.t(`general.${dayKeys.tue}`) },
						{ prop: dayKeys.wed, display: $i18next.t(`general.${dayKeys.wed}`) },
						{ prop: dayKeys.thu, display: $i18next.t(`general.${dayKeys.thu}`) },
						{ prop: dayKeys.fri, display: $i18next.t(`general.${dayKeys.fri}`) },
						{ prop: dayKeys.sat, display: $i18next.t(`general.${dayKeys.sat}`) },
						{ prop: dayKeys.sun, display: $i18next.t(`general.${dayKeys.sun}`) }
					];
				};
				fillUpDayMapper();

				attrs.$observe('pmtHours', function (newVal, oldVal) {
					if (newVal === oldVal) {
						return;
					}
					if (newVal) {
						let newHours = scope.$eval(newVal);
						scope.hoursSpecified = scope.hoursMapper.every(h => {
							if (newHours[h.prop] == null) {
								newHours[h.prop] = {};
							}

							return newHours[h.prop].state !== 'NotSpecified';
						});
						scope.hours = newHours;
						// Making sure that newHours does not contain foreign keys
						scope.maxSpan = Math.max(
							...Object.entries(newHours)
								.filter(([k]) => !!dayKeys[k])
								.map(([_k, v]) => v.span?.length || 0)
						);
						fillUpDayMapper();
					}
				});

				attrs.$observe('disableHeader', function (newVal) {
					scope.showHeader = !scope.$eval(newVal);
				});

				scope.getHourObjectByDayKey = function (dayKey) {
					return scope.hours[dayKey];
				};

				scope.hasDiff = function (openHourDay, day, spanIndex) {
					if (scope.diffObject == null) {
						return false;
					}
					if (openHourDay == null) {
						return true;
					}

					let diffSpan =
						(scope.diffObject[day].span && scope.diffObject[day].span[spanIndex]) || {};
					let openHourDaySpan = openHourDay.span[spanIndex] || {};
					return openHourDaySpan.open !== diffSpan.open || openHourDaySpan.close !== diffSpan.close;
				};
			},
			templateUrl: 'shared/dataPrinters/pmtHoursView.html'
		};
	}
]);
